import { render, staticRenderFns } from "./data38.vue?vue&type=template&id=314c6bb7&scoped=true&"
import script from "./data38.vue?vue&type=script&lang=js&"
export * from "./data38.vue?vue&type=script&lang=js&"
import style1 from "./data38.vue?vue&type=style&index=1&id=314c6bb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314c6bb7",
  null
  
)

export default component.exports